module.exports = __webpack_public_path__ + "c9fd20c7a8e85f417c0f6339e1d56bc1.fbx";